class CustomBundle extends HTMLElement {
  connectedCallback() {
    this.slotCount = parseInt(this.dataset.slotCount) || 3;
    this.bundleVariantId = parseInt(this.dataset.bundleVariantId);

    try {
      this.packOptions = JSON.parse(this.dataset.packOptions || '[]');
    } catch(e) { this.packOptions = []; }

    try {
      this.productsInfo = JSON.parse(this.dataset.productsInfo || '[]');
    } catch(e) { this.productsInfo = []; }

    this.selects = this.querySelectorAll('[data-slot-select]');
    this.errorEl = this.querySelector('[data-ref="cb-error"]');
    this.slotsContainer = this.querySelector('.cb-slots');

    this.nativeAtcBtn =
      this.closest('[data-ref="product-form"]')?.querySelector('[data-ref="add-to-cart"]') ||
      document.querySelector('[data-ref="add-to-cart"]');

    this.productForm =
      this.closest('form[action="/cart/add"]') ||
      document.querySelector('form[action="/cart/add"]');

    this.#renderPackButtons();

    if (this.packOptions.length > 0) {
      this.#selectPack(this.packOptions[0]);
    }

    this.selects.forEach(select => {
      select.addEventListener('change', () => this.#onSelectChange(select));
    });

    if (this.productForm) {
      this.productForm.addEventListener('submit', (e) => this.#onFormSubmit(e), true);
    }

    this.selects.forEach(select => {
      if (select.value) select.closest('.cb-slot')?.classList.add('cb-slot--filled');
    });

    this.#updateState();
  }

  #renderPackButtons() {
  if (!this.packOptions || this.packOptions.length === 0) return;

  this.querySelectorAll('.cb-pack').forEach(btn => {
    btn.addEventListener('click', () => {
      const pack = this.packOptions.find(
        p => p.index === parseInt(btn.dataset.packIndex)
      );

      if (pack) this.#selectPack(pack);
    });
  });
}

  #selectPack(pack) {
    this.slotCount = pack.slotCount;
    this.bundleVariantId = pack.variantId;

    const hiddenInput = this.productForm?.querySelector('input[name="id"]')
      || document.querySelector('form[action="/cart/add"] input[name="id"]');
    if (hiddenInput) hiddenInput.value = pack.variantId;

    const radio = document.querySelector(
      `variant-picker input[type="radio"][data-variant-id="${pack.variantId}"]`
    );
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.querySelectorAll('.cb-pack').forEach(btn => {
      const isActive = parseInt(btn.dataset.packIndex) === pack.index;
      btn.classList.toggle('cb-pack--active', isActive);
      btn.setAttribute('aria-pressed', isActive);
    });

    this.querySelectorAll('[data-slot]').forEach(slot => {
      const slotIndex = parseInt(slot.dataset.slot);
      slot.style.display = slotIndex <= this.slotCount ? '' : 'none';
      if (slotIndex > this.slotCount) {
        const select = slot.querySelector('[data-slot-select]');
        if (select) {
          select.value = '';
          slot.classList.remove('cb-slot--filled');
          const thumb = this.querySelector(`[data-ref="cb-thumb-${slotIndex}"]`);
          if (thumb) thumb.innerHTML = '';
          const infos = this.querySelector(`[data-ref="cb-infos-${slotIndex}"]`);
          if (infos) infos.innerHTML = '';
        }
      }
    });

    this.#updateState();
  }

  #onSelectChange(select) {
    const slot = select.closest('.cb-slot');
    const slotIndex = select.dataset.slotSelect;
    slot.classList.toggle('cb-slot--filled', !!select.value);

    const opt = select.options[select.selectedIndex];
    const variantId = parseInt(select.value);

    const thumb = this.querySelector(`[data-ref="cb-thumb-${slotIndex}"]`);
    if (thumb) {
      const img = opt?.dataset.image;
      thumb.innerHTML = img
        ? `<img src="${img}" alt="${opt.dataset.title || ''}" width="40" height="40" loading="lazy">`
        : '';
    }

    const infosEl = this.querySelector(`[data-ref="cb-infos-${slotIndex}"]`);
    if (infosEl) {
      const info = this.productsInfo.find(p => p.id === variantId);
      let html = '';
      if (info) {
        if (info.i1l && info.i1v) html += `<p class="cb-slot__info"><strong>${info.i1l}</strong> ${info.i1v}</p>`;
        if (info.i2l && info.i2v) html += `<p class="cb-slot__info"><strong>${info.i2l}</strong> ${info.i2v}</p>`;
        if (info.i3l && info.i3v) html += `<p class="cb-slot__info"><strong>${info.i3l}</strong> ${info.i3v}</p>`;
      }
      infosEl.innerHTML = html;
    }

    this.#updateState();
  }

  #getSelectedItems() {
    const items = [];
    this.querySelectorAll('[data-slot-select]').forEach(select => {
      const slotIndex = parseInt(select.dataset.slotSelect);
      if (slotIndex > this.slotCount) return;
      if (select.value) {
        const opt = select.options[select.selectedIndex];
        items.push({ id: parseInt(select.value), title: opt.dataset.title || opt.text || '' });
      }
    });
    return items;
  }

  #allFilled() {
    if (this.dataset.hideSlots === 'true') return true;
    return this.#getSelectedItems().length === this.slotCount;
  }

  #updateState() {
    if (this.nativeAtcBtn) this.nativeAtcBtn.disabled = !this.#allFilled();
    if (this.errorEl) this.errorEl.style.display = 'none';
  }

  async #onFormSubmit(e) {
    const hideSlots = this.dataset.hideSlots === 'true';
    const items = this.#getSelectedItems();

    if (!hideSlots && items.length !== this.slotCount) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.errorEl) this.errorEl.style.display = 'block';
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (this.errorEl) this.errorEl.style.display = 'none';

    const properties = {};
    if (!hideSlots) {
      items.forEach((item, index) => {
        properties[`Savon ${index + 1}`] = item.title;
      });
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: this.bundleVariantId, quantity: 1, properties }]
        })
      });

      if (!response.ok) throw new Error('Cart error');

      const sectionId = document.querySelector('[data-ref="cart-drawer"]')?.dataset.sectionId;
      if (sectionId) {
        const refreshRes = await fetch(`/?sections=${sectionId}`);
        const refreshData = await refreshRes.json();
        const html = refreshData[sectionId];
        if (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            currentDrawer.className = newDrawer.className;
          }
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));

    } catch (err) {
      console.error('Custom bundle error:', err);
      if (this.errorEl) {
        this.errorEl.textContent = "Erreur lors de l'ajout au panier. Réessayez.";
        this.errorEl.style.display = 'block';
      }
    }
  }
}

customElements.define('custom-bundle', CustomBundle);